import React from "react";
import Auth from '../utils/auth';
const auth = new Auth();

// hardcoded amount (in US cents) to charge users
// you could set this variable dynamically to charge different amounts
const amount = 2500;
const cardStyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: "flex-start",
  padding: "3rem",
  boxShadow: "5px 5px 25px 0 rgba(46,61,73,.2)",
  backgroundColor: "#fff",
  borderRadius: "6px",
  maxWidth: "400px",
};
// const buttonStyles = {
//   fontSize: "13px",
//   textAlign: "center",
//   color: "#fff",
//   outline: "none",
//   padding: "12px 60px",
//   boxShadow: "2px 5px 10px rgba(0,0,0,.1)",
//   // backgroundColor: "#2196f3",
//   borderRadius: "6px",
//   letterSpacing: "1.5px",
// };

// Below is where the checkout component is defined.
// It has several functions, and some default state variables.
const Checkout = class extends React.Component {
  state = {
    disabled: false,
    buttonText: "SUBSCRIBE NOW",
    paymentMessage: "",
    backgroundColor: "#2196f3",
    stages:"",
  };

  login(email) {
    //const type = {type: 'signup'};
    const email2 = {email: email};
    //console.log(email);
    auth.login(email2);
  }

  resetButton() { 
    this.setState({ disabled: false, backgroundColor: "#2196f3", buttonText: "SUBSCRIBE NOW" });
  }

  componentDidMount() {
    this.stripeHandler = StripeCheckout.configure({
      // You’ll need to add your own Stripe public key to the `checkout.js` file.
      // key: 'pk_test_STRIPE_PUBLISHABLE_KEY',
      //key: "pk_test_3fFW5HBGfB5gUSMdFtFUg1sK",
      key: "pk_live_qJyqeuXML1bciXDdz0sPwQrd",
      closed: () => {
          // this.setState({stage: "",});
          this.resetButton();
      },
    });

    if (auth.isAuthenticated()) {
      this.setState({ disabled: true, backgroundColor: "#4caf50", stage:"", buttonText: "PURCHASED" });
    }
  }

    componentDidUpdate(prevProps, prevState) {
      // console.log(prevProps);
      // console.log(prevState);
      if ((prevState.stage!="AlreadySubscribed") && (this.state.stage === "AlreadySubscribed")){
        this.setState({ backgroundColor: "#f44336", stage:"AlreadySubscribed", disabled: true, buttonText: "Payment Failed. You are already subscribed" });
      } 
      if ((prevState.stage!="PaymentFailed") && (this.state.stage === "PaymentFailed")){
        this.setState({ backgroundColor: "#f44336", stage:"PaymentFailed", disabled: true, buttonText: "Payment Failed. Try Again" });
      } 
      if ((prevState.stage!="Error") && (this.state.stage === "Error")){
        this.setState({ backgroundColor: "#f44336", stage:"Error", disabled: true, buttonText: "Error, Try Again" });
      } 
      if ((this.state.stage === "Payment") && (this.state.buttonText === "SUBSCRIBE NOW") ){
         this.setState({ disabled: true, backgroundColor: "#009688", buttonText: "WAITING..." });
      }
      if ((this.state.buttonText != "SUBSCRIBE NOW") && (!auth.isAuthenticated()) && (this.state.stage != "Payment") && (this.state.stage!="AlreadySubscribed") && (this.state.stage != "PaymentFailed") && (this.state.stage != "Error") ){
        this.setState({ disabled: false, backgroundColor: "#2196f3", buttonText: "SUBSCRIBE NOW" });
      } 
    }

  openStripeCheckout(event) {
    event.preventDefault();
    this.setState({ disabled: true, stage:"Payment", buttonText: "WAITING..." });
    this.stripeHandler.open({
      name: "ftbcAcademy Special",
      currency: 'sgd',
      amount: amount,
      description: "1 time charge for 2019 full access",
      token: token => {
        fetch(`https://4u5encr06m.execute-api.us-east-1.amazonaws.com/dev/checkout`, {
          method: "POST",
          body: JSON.stringify({
            token,
            amount,
          }),
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        })
          .then(res => {
            // this.login().bind(this);
            this.setState({ disabled: true, stage:"Payment", backgroundColor: "#00695f", buttonText: "Pls wait for signup screen..." });
            return res.json();
          })
          .then( result =>{
            console.log(result)
            console.log(result.error)
            if (!result.error){
              console.log("Transaction processed successfully");
              //this.setState({ backgroundColor: "#4caf50", buttonText: "Payment Successful!" });
              this.setState({ disabled: true, backgroundColor: "#00695f", buttonText: "Pls wait for signup screen..." });
              this.login(result.email);
            } else{
              if (result.error="Must provide source or customer."){
                console.log("You are already subscribed");
                this.setState({ backgroundColor: "#f44336", stage:"AlreadySubscribed", disabled: true, buttonText: "Payment Failed. You are already subscribed" });
              } else {
                console.log("Payment Failed");
                this.setState({ backgroundColor: "#f44336", stage:"PaymentFailed", buttonText: "Payment Failed. Try Again" });
              }
            }
            // console.log(result.email)
            //this.login(result.email);
          })
          .catch(error => {
            console.log(error);
            this.setState({ backgroundColor: "#f44336", stage:"Error", buttonText: "Error, Try Again" });
          });
      },
    });
  }

  render() {
    const buttonStyles = {
      fontSize: "13px",
      textAlign: "center",
      color: "#fff",
      outline: "none",
      padding: "12px 60px",
      boxShadow: "2px 5px 10px rgba(0,0,0,.1)",
      backgroundColor: this.state.backgroundColor,
      borderRadius: "6px",
      letterSpacing: "1.5px",
    };
    return (
      <div>
        <button
          style={buttonStyles}
          onClick={event => this.openStripeCheckout(event)}
          disabled={this.state.disabled}
        >
          {this.state.buttonText}
        </button>
        {this.state.paymentMessage}
      </div>
    );
  }
};

export default Checkout;


// WEBPACK FOOTER //
// ./src/components/checkout.jsx